export default "__VITE_ASSET__CLT0QIUS__"